const srebrzysko = {
  var: 'srebrzysko',
  name: 'SREBRZYSKO',
  color: 'violet',
};
const oliwa = {
  var: 'oliwa',
  name: 'OLIWA',
  color: 'brown',
};
const lostowice = {
  var: 'lostowice',
  name: 'ŁOSTOWICE',
  color: 'orange',
};

const cemeteries = [lostowice, oliwa, srebrzysko];

export { srebrzysko, lostowice, oliwa, cemeteries };



// WEBPACK FOOTER //
// ./src/js/constants.js